"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppToFeatureStringKey = exports.AppNames = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AppToFeatureStringKe;

var AppNames = {
  CONVERSATIONS_SETTINGS: 'conversations-settings',
  LEAD_FLOWS: 'lead-flows',
  FORMS: 'forms',
  MEETINGS: 'meetings',
  DOCUMENTS: 'documents',
  CONVERSION_TOOLS: 'conversion-tools',
  EMAIL: 'email'
};
exports.AppNames = AppNames;
var AppToFeatureStringKey = (_AppToFeatureStringKe = {}, (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.CONVERSATIONS_SETTINGS, 'liveChat'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.LEAD_FLOWS, 'leadFlows'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.FORMS, 'forms'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.MEETINGS, 'bookingPage'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.DOCUMENTS, 'documents'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.CONVERSION_TOOLS, 'forms'), (0, _defineProperty2.default)(_AppToFeatureStringKe, AppNames.EMAIL, 'email'), _AppToFeatureStringKe);
exports.AppToFeatureStringKey = AppToFeatureStringKey;